module.exports = __webpack_public_path__ + "img/20191116143452385.7c9dffd1.jpg";